import { Skeleton } from '@/components/shadcn/skeleton'

export function FormComponentLoading() {
  const lines = Array.from({ length: 10 }, (_, i) => i)
  return (
    <div className="flex w-full flex-col gap-y-4 pt-5">
      {lines.map((line) => (
        <Skeleton key={line} className="h-8 max-w-2xl" />
      ))}
    </div>
  )
}
